<template>
    <div id="bene-aud-bt-business-container">
        <f7-list form class="form-group" v-if="showFormInput.kaasiDetails.auBusiness">
            <f7-list-input
                input-id     ="audAbn"
                name         ="audAbn"
                type         ="text"

                :label       ="$t('beneficiary-abn')"
                :placeholder ="$t('beneficiary-abn')"
                :value       ="audAbn"
                @change      ="setAudAbn($event.target.value); validateInput($event.target); setInput($event.target)"

                autocomplete ="off"
                outline
                floating-label
                clear-button
            ></f7-list-input>

            <f7-list-input
                input-id     ="audAcn"
                name         ="audAcn"
                type         ="text"

                :label       ="$t('beneficiary-acn')"
                :placeholder ="$t('beneficiary-acn')"
                :value       ="audAcn"
                @change      ="setAudAcn($event.target.value); validateInput($event.target); setInput($event.target)"

                autocomplete ="off"
                outline
                floating-label
                clear-button
            ></f7-list-input>
        </f7-list>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    export default {
        props: {
        },
        mounted() {
        },
        data: function() {
            return {}
        },
        computed: {
            ...mapGetters('beneficiary', [
                'showFormSet',
                'showFormInput',
                'audAbn',
                'audAcn',
            ])
        },
        methods: {
            ...mapActions('beneficiary', [
                'setAudAbn',
                'setAudAcn'
            ]),

            validateInput(inputEl){
                this.$emit("validateInput", inputEl);
            },

            setInput(inputEl){
                this.$emit("setInput", inputEl);
            }
        }
    }
</script>